import { render, staticRenderFns } from "./BarChartBudgetTechnical.vue?vue&type=template&id=081dae34"
import script from "./BarChartBudgetTechnical.vue?vue&type=script&lang=js"
export * from "./BarChartBudgetTechnical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports